import type { Util } from '../../../types/util';

const base: Util.VariantCSSKeys<MultipleImageVariantsType> = {
  dark: {
    backgroundColor: 'coolGrey.100',
    '& h1, & p': {
      color: 'white',
    },
  },
  light: {
    backgroundColor: 'none',
    '& h1, & p': {
      color: 'coolGrey.100',
    },
  },
};

const multipleImage: Util.VariantKeyModes<MultipleImageVariantsType> = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    scale: base,
    spark: base,
  },
};

export type MultipleImageVariantsType = 'dark' | 'light';
export const multipleImageVariants = Object.keys(base) as MultipleImageVariantsType[];

export default multipleImage;
